<div class="object-copy-media">
  <mat-checkbox
    [checked]="isFieldSelected()"
    [indeterminate]="isFieldIndeterminate()"
    (change)="onFieldToggleChange($event)"
  >
    <app-display-field-title
      [field]="viewField()"
      class="object-copy-field__title"
    />
  </mat-checkbox>
  <div class="object-copy-media__items">
    @for (item of items; track item.artifact_id) {
      <app-thumbnail-item
        class="object-copy-media__item"
        [item]="item"
        [isSelected]="itemIsSelected(item)"
        (changed)="toggleItem($event.event.checked, item)"
      />
    }
  </div>
</div>
